import Button from 'react-bootstrap/Button';
import './App.css';
import Form from 'react-bootstrap/Form';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Toolbar } from './components/Toolbar';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useFormik } from 'formik';
import logo from './assets/fedex-logo.png';
import * as Yup from 'yup';
import { ShipmentDetails } from './components/ShipmentDetails/ShipmentDetails';
import { ShipAlert } from './components/ShipAlert';
import { Commodities } from './components/Commodities';
import { useNotifications } from './contexts/NotificationsContext';
import { Customs } from './components/Customs';
import { Options } from './components/Options';
import ZebraBrowserPrintWrapper from 'zebra-browser-print-wrapper';
import { printBase64Pdf } from './utils/print';
import { ReturnShipmentDetails } from './components/ShipmentDetails/ReturnShipmentDetails';
import defaultSignature from './assets/stan-signature.png';
import { initialFormData } from './utils/formikFields';
import { OrderLookupModal } from './components/Modals/OrderLookupModal';
import { PrintDocsModal } from './components/Modals/PrintDocsModal';
import { getLocalDateTimeString } from './utils/localDateTime';

const etdRelatedErrorCodes = ['SHIPMENT.SHIPPINGDOCUMENT.PROHIBITED'];

function App() {
  const { addNotification } = useNotifications();
  const [submitLoading, setSubmitLoading] = useState(false);
  const [specialServicesLoading, setSpecialServicesLoading] = useState(false);
  const [showLookup, setShowLookup] = useState(false);
  const [showPrintDocs, setShowPrintDocs] = useState(false);
  const [tabKey, setTabKey] = useState('shipmentDetails');
  const [nestedTabKey, setNestedTabKey] = useState('returnShipmentDetails')
  const [aptifyFormFields, setAptifyFormFields] = useState([]);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [documentsToPrint, setDocumentsToPrint] = useState([]);
  const [hideLookup, setHideLookup] = useState(false);
  const onReturnTab = tabKey === 'returnShipment';

  const handleShowLookup = () => setShowLookup(true);
  const handleCloseLookup = () => setShowLookup(false);
  const handleShowPrintDocs = () => setShowPrintDocs(true);
  const handleClosePrintDocs = () => setShowPrintDocs(false);
  const updateHideLookup = (newVal) => setHideLookup(newVal);
  const handleReset = () => {
    formik.handleReset();
    setHideLookup(false);
  }
  const resetTabs = (mainTabName) => {
    setTabKey(mainTabName);
    setNestedTabKey('returnShipmentDetails');
  }

  useEffect(() => {
    if (!submitLoading && documentsToPrint.length > 0) {
      handleShowPrintDocs();
    }
  }, [documentsToPrint])

  const lookupPackage = async () => {
    if (!formik.values.orderNum) return alert('Please enter a package number to look up.');
    try {
      setFetchLoading(true);
      const url = `${process.env.REACT_APP_BASE_URL}/aptify/fedex/${formik.values.orderNum}`;
      const result = await axios.get(url);
      const formFields = result.data && result.data.formFields;
      if (!formFields) {
        addNotification('Something went wrong.', 'No data retrieved.', 'danger');
        setFetchLoading(false);
        return;
      };
      setAptifyFormFields(formFields);
      setHideLookup(true);
      handleCloseLookup();
      setFetchLoading(false);
    } catch (err) {
      console.log('Error getting form values: ' + err);
      addNotification('Error loading form values.', err.message, 'danger');
      handleCloseLookup();
      setFetchLoading(false);
    }
  }

  const handleLookupKeyDown = (e) => {
    if (e.key === 'Enter') lookupPackage();
  }

  const getSpecialServices = async (isReturnShipmentTab) => {
    setSpecialServicesLoading(true);
    const url = `${process.env.REACT_APP_BASE_URL}/fedex/special/services`;
    const specialServicesField = isReturnShipmentTab ? 'returnData.specialServices' : 'specialServices';
    const values = isReturnShipmentTab ? formik.values.returnData : formik.values;
    const reqBody = {
      shipperAddress1: values.shipperAddress1,
      shipperAddress2: values.shipperAddress2,
      shipperCity: values.shipperCity,
      shipperState: values.shipperState,
      shipperPostalCode: values.shipperPostalCode,
      shipperCountry: values.shipperCountry,
      shipperResidentialAddress: values.shipperResidentialAddress,
      shipperName: values.shipperName,
      shipperEmail: values.shipperEmail,
      shipperTelephone: values.shipperTelephone,
      shipperCompany: values.shipperCompany,
      accountNum: values.accountNum,
      address1: values.address1,
      address2: values.address2,
      address3: values.address3,
      city: values.city,
      stateProvince: values.stateProvince,
      postalCode: values.postalCode,
      country: values.country,
      residential: values.residentialAddress,
      contactName: values.contactName,
      ext: values.ext,
      telephone: values.telephone,
      companyName: values.companyName,
      serviceType: values.serviceType,
      packageType: values.packageType,
      declaredValue: values.declaredValue,
      declaredValueCurrency: values.declaredValueCurrency,
      weight: values.weight,
      weightUnit: values.weightUnit,
      length: values.length,
      width: values.width,
      height: values.height,
      dimensionsUnit: values.dimensionsUnit,
      isReturn: isReturnShipmentTab ? true : false
    }

    try {
      const result = await axios.post(url, reqBody);
      const data = result.data.data;
      const serviceOptionsList = data.output.serviceOptionsList;
      let specialServicesArray = [];
      for (const obj of serviceOptionsList) {
        const pacakgeServices = obj.packageSpecialServicesList ? obj.packageSpecialServicesList.map((i) => ({ ...i, level: 'package' })) : [];
        const shipmentServices = obj.shipmentSpecialServicesList ? obj.shipmentSpecialServicesList.map((i) => ({ ...i, level: 'shipment' })) : [];
        specialServicesArray = [...specialServicesArray, ...pacakgeServices, ...shipmentServices];
      }
      const hiddenServices = ['HEALTHCARE_IDENTIFIER_OPTIONS', 'SIGNATURE_OPTION', 'ELECTRONIC_TRADE_DOCUMENTS'];
      specialServicesArray = specialServicesArray.filter((i) => !hiddenServices.includes(i.specialServiceType));
      formik.setFieldValue(specialServicesField, specialServicesArray);
      setSpecialServicesLoading(false);
    } catch (err) {
      setSpecialServicesLoading(false);
      formik.setFieldValue(specialServicesField, []);
      const errDetails = err.response.data.details.errors && err.response.data.details.errors.length > 0 ? err.response.data.details.errors[0].code : '';
      addNotification('Error getting special services.', errDetails || err.message, 'danger');
      console.log('Something went wrong when fetching special servcices: ' + err);
    }
  }

  const encodeFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const base64String = event.target.result.split(',')[1];
        resolve(base64String);
      }
      reader.onerror = (event) => {
        reject(event.target.error);
      }
      reader.readAsDataURL(file);
    })
  }

  const handleEtdWarningNotification = (alerts) => {
    let warningToDisplay;
    for (const alert of alerts) {
      if (etdRelatedErrorCodes.includes(alert.code)) {
        warningToDisplay = alert;
        break;
      }
    }
    if (warningToDisplay) {
      addNotification(warningToDisplay.code, warningToDisplay.message || 'Customs documents may need to be handled manually for this shipment.', 'warning');
    }
  }

  const handleSubmit = async (values) => {
    setSubmitLoading(true);
    const docs = [];
    const returnCopy = { ...values.returnData };
    const outboundCopy = { ...values };
    delete outboundCopy.returnData;
    returnCopy.requestPdfLabels = outboundCopy.requestPdfLabels;
    const today = getLocalDateTimeString().slice(0, 10);
    if (!outboundCopy.shipDate || outboundCopy.shipDate < today) outboundCopy.shipDate = today;
    if (!returnCopy.shipDate || returnCopy.shipDate < today) returnCopy.shipDate = today;
    // remove below line if you DON'T want aptify update (tracking number overwritten) for "include return label" shipments
    // if (outboundCopy.orderNum) returnCopy.orderNum = outboundCopy.orderNum;
    const checkNumPackagesResult = checkNumPackages([outboundCopy, returnCopy]);
    if (!checkNumPackagesResult) {
      setSubmitLoading(false);
      return alert('Mismatch between "Number of packages" field and actual number of packages added in multiple piece shipment modal.');
    }
    try {
      if (values.isReturnOnly) {
        const result = await createShipment(returnCopy);
        if (result.documents.length > 0) {
          docs.push(...result.documents);
        }
      } else {
        const result = await createShipment(outboundCopy);
        if (result.documents.length > 0) {
          docs.push(...result.documents);
        }
        const outboundTrackingNum = result.masterTrackingNum;
        if (values.includeReturnLabel) {
          if (returnCopy.linkToOutbound) {
            returnCopy.outboundTrackingNum = outboundTrackingNum;
            returnCopy.outboundShipDate = outboundCopy.shipDate;
          }
          const result = await createShipment(returnCopy);
          if (result.documents.length > 0) {
            docs.push(...result.documents);
          }
        }
      }
      addNotification('Form submitted successfully.', '', 'success');
      setSubmitLoading(false);
      handleReset();
      if (tabKey !== 'shipmentDetails') {
        setTabKey('shipmentDetails');
      }
      if (docs.length === 1 && docs[0].type === 'COMMERCIAL_INVOICE' && (!outboundCopy.electronicallyUploadTradeDocs || !returnCopy.electronicallyUploadTradeDocs)) {
        printBase64Pdf(docs[0].document);
      } else if (docs.length === 1 && docs[0].type === 'LABEL') {
        printBase64Pdf(docs[0].document);
      } else if (docs.length > 0) {
        setDocumentsToPrint(docs); // triggers print documents modal
      }
    } catch (err) {
      setSubmitLoading(false);
      console.log('Error submitting form.');
      console.log(err);
      const errors = err.response?.data.details?.errors || '';
      if (errors) {
        addNotification(errors[0].code, `${err.source} ERROR: ${errors[0].message}`, 'danger');
      } else {
        addNotification('Error submitting form, something went wrong.', err.message, 'danger');
      }
    }
  }

  const checkNumPackages = (payloads) => {
    for (const payload of payloads) {
      if (payload.numPackages > 1 && !payload.identicalPackages && payload.mpsPackages.length !== payload.numPackages) {
        return false;
      }
    }
    return true;
  }

  const createShipment = async (values) => {
    values.packageSpecialServices = values.specialServices.filter((item) => (item.level === 'package') && (item.selected === true));
    values.shipmentSpecialServices = values.specialServices.filter((item) => (item.level === 'shipment') && (item.selected === true));
    if (values.readyPickupDateTime && values.latestPickupDateTime) {
      values.readyPickupDateTime = getLocalDateTimeString(values.readyPickupDateTime).split('.')[0] + 'Z';
      values.latestPickupDateTime = getLocalDateTimeString(values.latestPickupDateTime).split('.')[0] + 'Z';
      values.shipDate = values.readyPickupDateTime.split('T')[0];
    }
    // need to check if there are shipAlert selections, and if so then push the special service object onto the array
    let emailNotificationsSelected;
    const shipAlertKeys = Object.keys(values.shipAlerts);
    for (const key of shipAlertKeys) {
      if (values.shipAlerts[key].notificationEventType.length > 0) {
        emailNotificationsSelected = true;
        break;
      }
    }
    if (emailNotificationsSelected) {
      const obj = {
        specialServiceType: 'EVENT_NOTIFICATION',
        level: 'shipment'
      }
      values.shipmentSpecialServices.push(obj);
    }

    if (values.signatureOption) {
      const obj = {
        specialServiceType: 'SIGNATURE_OPTION',
        details: values.signatureOption,
        level: 'package'
      }
      values.packageSpecialServices.push(obj);
    }
    if (values.returnLabelType) {
      const labelType = values.returnLabelType;
      const obj = {
        specialServiceType: 'RETURN_SHIPMENT',
        level: 'shipment',
        details: {}
      }
      if (values.rmaNum) {
        obj.details.rma = values.rmaNum;
      }
      if (values.outboundTrackingNum) {
        obj.details.trackingNum = values.outboundTrackingNum;
        obj.details.shipDate = values.outboundShipDate;
      }
      let obj2;
      if (labelType === 'PENDING') {
        obj.details.returnType = 'PENDING';
        obj.details.telephone = values.shipperTelephone;
        obj2 = {
          specialServiceType: 'PENDING_SHIPMENT',
          level: 'shipment',
          details: {
            email: values.emailLabelTo, // TODO could add conditional validation on this field (and maybe others related to returns) since it's required
            expiration: values.emailReturnExpirationDate
          }
        }
      }
      if (labelType === 'PRINT_RETURN_LABEL') {
        obj.details.returnType = 'PRINT_RETURN_LABEL';
      }
      if (labelType === 'GROUND_CALL_TAG') {
        obj.details.returnType = 'FEDEX_TAG';
      }
      values.shipmentSpecialServices.push(obj);
      if (obj2) values.shipmentSpecialServices.push(obj2);
    }
    if (values.mpsPackages.length > 0) {
      for (const pkg of values.mpsPackages) {
        if (pkg.signatureOption) {
          const obj = {
            specialServiceType: 'SIGNATURE_OPTION',
            details: pkg.signatureOption,
            level: 'package'
          }
          pkg.specialServices = [...pkg.specialServices, obj];
        }
      }
    }
    if (values.packageContains === 'document') {
      values.isDocumentOnly = true;
    } else {
      values.isDocumentOnly = false;
    }
    if (values.electronicallyUploadTradeDocs && (values.includeCommercialInvoicePf || values.includeCertOfOrigin)) {
      const obj = {
        specialServiceType: 'ELECTRONIC_TRADE_DOCUMENTS',
        level: 'shipment',
        details: {
          attachedDocuments: [],
          requestedDocumentTypes: []
        }
      }
      if (values.includeCommercialInvoicePf) {
        if (values.commercialInvoicePfSource.includes('upload now') && values.commercialInvoice) {
          const base64String = await encodeFile(values.commercialInvoice);
          const docDetails = {
            encodedFile: base64String,
            fileType: values.commercialInvoice.type,
            orderNum: values.orderNum,
            shipDocType: 'COMMERCIAL_INVOICE',
            destinationCountry: values.country
          }
          obj.details.attachedDocuments.push(docDetails);
        } else if (values.commercialInvoicePfSource.includes('Auto-generated')) {
          obj.details.requestedDocumentTypes.push('COMMERCIAL_INVOICE');
        }
      }
      if (values.includeCertOfOrigin) {
        if (values.certOfOrigin) {
          const base64String = await encodeFile(values.certOfOrigin);
          const docDetails = {
            encodedFile: base64String,
            fileType: values.certOfOrigin.type,
            orderNum: values.orderNum,
            shipDocType: values.certOfOriginSource.includes('USMCA') ? 'USMCA_CERTIFICATION_OF_ORIGIN' : 'CERTIFICATE_OF_ORIGIN',
            destinationCountry: values.country
          }
          obj.details.attachedDocuments.push(docDetails);
        }
      }
      if (obj.details.attachedDocuments.length === 0) delete obj.details.attachedDocuments;
      if (obj.details.requestedDocumentTypes.length === 0) delete obj.details.requestedDocumentTypes;
      if (Object.keys(obj.details).length > 0) values.shipmentSpecialServices.push(obj);
    }
    if (values.commercialInvoicePfSource.includes('Auto-generated') && (values.insertLetterheadImg || values.insertSignatureImg)) {
      if (values.useDefaultSignatureImg) {
        const response = await fetch(defaultSignature);
        const blob = await response.blob();
        blob.name = 'signature-img.png';
        const file = new File([blob], blob.name, { type: blob.type });
        values.signatureImg = file;
      }
      const url = `${process.env.REACT_APP_BASE_URL}/fedex/images/upload`;
      const formData = new FormData();
      if (values.insertLetterheadImg && values.letterheadImg) formData.append('letterheadImg', values.letterheadImg);
      if (values.insertSignatureImg && values.signatureImg) formData.append('signatureImg', values.signatureImg);
      formData.append('orderNum', values.orderNum);
      try {
        const response = await axios.post(url, formData);
        const result = response.data;
        values.letterheadImgIndex = result.data.letterheadImg;
        values.signatureImgIndex = result.data.signatureImg;
      } catch (err) {
        const errDetails = err.response && err.response.data && err.response.data.details.errors && err.response.data.details.errors.length > 0 ? err.response.data.details.errors[0].code : '';
        throw new Error(`Error uploading document images: ${errDetails || err.message}`);
      }
    }
    try {
      const isGroundCallTag = values.returnLabelType === 'GROUND_CALL_TAG';
      const path = isGroundCallTag ? '/fedex/create/tag' : '/fedex/create';
      const url = `${process.env.REACT_APP_BASE_URL}${path}`;
      const response = await axios.post(url, values);
      const alerts = response.data.data.fullResponse.output.transactionShipments && response.data.data.fullResponse.output.transactionShipments[0].alerts;
      if (alerts) {
        handleEtdWarningNotification(alerts);
      }
      const masterTrackingNum = response.data.data.masterTrackingNum;
      const trackingNum = response.data.data.trackingNum;
      const carrierCode = response.data.data.carrierCode;
      if (values.orderNum) {
        updateAptifyOrder(values.orderNum, masterTrackingNum);
      }
      // add any extra fields to values before sending - like tracking number
      values.masterTrackingNum = masterTrackingNum;
      values.trackingNum = trackingNum;
      values.carrierCode = carrierCode;
      addAptifyShipmentRecord(values);
      const labels = response.data.data.labels;
      const documents = response.data.data.encodedDocuments;
      if (labels.length > 0 && !values.requestPdfLabels) {
        for (const label of labels) {
          await printLabel(label, 1);
        }
      } else if (labels.length > 0 && values.requestPdfLabels) {
        const labelObjects = labels.map((label) => ({ document: label, type: 'LABEL' }))
        documents.unshift(...labelObjects);
      }
      if (values.returnLabelType && values.returnLabelType !== 'PRINT_RETURN_LABEL') {
        const labelType = values.returnLabelType === 'PENDING' ? 'Email' : 'Ground call tag'
        addNotification(`${labelType} return label created successfully.`, '', 'success');
      }
      return { masterTrackingNum, documents };
    } catch (err) {
      err.source = values.returnLabelType ? 'RETURN' : 'OUTBOUND';
      throw err;
    }
  }

  const updateAptifyOrder = async (orderNum, masterTrackingNum) => {
    const url = `${process.env.REACT_APP_BASE_URL}/aptify/order/update`
    const payload = {
      orderNum,
      masterTrackingNum
    }
    try {
      await axios.post(url, payload);
    } catch (err) {
      addNotification('Error updating Aptify record.', err.message, 'danger');
    }
  }

  const addAptifyShipmentRecord = async (values) => {
    const url = `${process.env.REACT_APP_BASE_URL}/aptify/shipment`
    try {
      await axios.post(url, values);
    } catch (err) {
      addNotification('Error creating Aptify shipment record.', err.message, 'danger');
    }
  }

  const printLabel = async (zpl, attempt) => {
    const wrapper = new ZebraBrowserPrintWrapper();

    try {
      const printer = await wrapper.getDefaultPrinter();
      if (printer) {
        wrapper.setPrinter(printer);
        const status = await wrapper.checkPrinterStatus();
        if (status.isReadyToPrint) {
          await wrapper.print(zpl);
          addNotification('Label printed successfully.', '', 'success');
        } else {
          if (attempt === 1) {
            console.log('Printer not ready on first attempt, retrying...');
            printLabel(zpl, 2);
          } else {
            throw new Error('Printer not ready.');
          }
        }
      } else {
        throw new Error('Default printer not found.');
      }
    } catch (err) {
      console.log('Error printing label: ', err);
      throw new Error(`Error printing label: ${err.message}`);
    }
  }

  const mpsDynamicValidationOutbound = (errMessage) => {
    return Yup.string().when(['mpsPackages', 'isReturnOnly'], {
      is: (mpsFieldVal, isReturnOnlyVal) => {
        return mpsFieldVal.length === 0 && isReturnOnlyVal === false;
      },
      then: (schema) => schema.required(errMessage),
      otherwise: (schema) => schema.notRequired()
    })
  }

  const mpsDynamicValidationReturns = (errMessage) => {
    return Yup.string().when(['mpsPackages', '$includeReturnLabel', '$isReturnOnly'], {
      is: (mpsFieldVal, includeReturnLabelVal, isReturnOnlyVal) => {
        return mpsFieldVal.length === 0 && (includeReturnLabelVal === true || isReturnOnlyVal === true);
      },
      then: (schema) => schema.required(errMessage),
      otherwise: (schema) => schema.notRequired()
    })
  }

  const returnDynamicValidation = (errMessage) => {
    return Yup.string().when(['$includeReturnLabel', '$isReturnOnly'], {
      is: (includeReturnLabelVal, isReturnOnlyVal) => {
        return includeReturnLabelVal === true || isReturnOnlyVal === true;
      },
      then: (schema) => schema.required(errMessage),
      otherwise: (schema) => schema.notRequired()
    })
  }

  const outboundDynamicValidation = (errMessage) => {
    return Yup.string().when('isReturnOnly', {
      is: (isReturnOnlyVal) => isReturnOnlyVal === false,
      then: (schema) => schema.required(errMessage),
      otherwise: (schema) => schema.notRequired()
    })
  }

  const packageDescriptionDynamicValidation = (errMessage) => {
    return Yup.string().when(['returnLabelType', '$includeReturnLabel', '$isReturnOnly'], {
      is: (returnLabelTypeVal, includeReturnLabelVal, isReturnOnlyVal) => {
        return (returnLabelTypeVal === 'PENDING' || returnLabelTypeVal === 'GROUND_CALL_TAG') && (includeReturnLabelVal === true || isReturnOnlyVal === true);
      },
      then: (schema) => schema.required(errMessage),
      otherwise: (schema) => schema.notRequired()
    })
  }

  // TODO - can move this and related validation functions out to new file and import
  const validationSchema = Yup.object({
    accountNum: outboundDynamicValidation('Required'),
    address1: outboundDynamicValidation('Required'),
    city: outboundDynamicValidation('Required'),
    country: outboundDynamicValidation('Required'),
    telephone: outboundDynamicValidation('Required'),
    shipper: outboundDynamicValidation('Required'),
    companyName: Yup.string().max(35, 'Company name cannot exceed 35 characters'),
    serviceType: outboundDynamicValidation('Required'),
    packageType: outboundDynamicValidation('Required'),
    weight: mpsDynamicValidationOutbound('Weight and weightUnit are required'),
    weightUnit: mpsDynamicValidationOutbound('Weight and weightUnit are required'),
    returnData: Yup.object({
      accountNum: returnDynamicValidation('Required'),
      address1: returnDynamicValidation('Required'),
      city: returnDynamicValidation('Required'),
      country: returnDynamicValidation('Required'),
      telephone: returnDynamicValidation('Required'),
      shipper: returnDynamicValidation('Required'),
      companyName: Yup.string().max(35, 'Company name cannot exceed 35 characters'),
      serviceType: returnDynamicValidation('Required'),
      packageType: returnDynamicValidation('Required'),
      weight: mpsDynamicValidationReturns('Weight and weightUnit are required', true),
      weightUnit: mpsDynamicValidationReturns('Weight and weightUnit are required', true),
      packageDescription: packageDescriptionDynamicValidation('Package description required for this return type')
    })
  })

  const formik = useFormik({
    initialValues: initialFormData,
    enableReinitialize: true,
    validationSchema,
    onSubmit: handleSubmit
  })

  useEffect(() => {
    if (formik.values.packageType && formik.values.serviceType) {
      getSpecialServices(false);
    }
  }, [formik.values.packageType, formik.values.serviceType])

  useEffect(() => {
    if (formik.values.returnData.packageType && formik.values.returnData.serviceType) {
      getSpecialServices(true);
    }
  }, [formik.values.returnData.packageType, formik.values.returnData.serviceType])

  return (
    <>
      <Form className='my-form' onSubmit={formik.handleSubmit}>
        <div className='header'>
          <img src={logo} className='logo' alt='Fedex logo' />
          {!hideLookup && <Button onClick={handleShowLookup} className='purple-btn'>Lookup package(s)</Button>}
        </div>
        <Tabs
          activeKey={tabKey}
          onSelect={(k) => setTabKey(k)}
          className='mb-3'
        >
          <Tab eventKey='shipmentDetails' title='Shipment details' disabled={formik.values.isReturnOnly}>
            <ShipmentDetails
              formik={formik}
              getSpecialServices={getSpecialServices}
              specialServicesLoading={specialServicesLoading}
              formFields={aptifyFormFields}
              tabKey={tabKey}
            />
          </Tab>
          <Tab eventKey='options' title='Options' disabled={formik.values.isReturnOnly}>
            <Options formik={formik} isReturnShipmentTab={false} />
          </Tab>
          <Tab eventKey='shipAlert' title='ShipAlert' disabled={formik.values.isReturnOnly}>
            <ShipAlert formik={formik} isReturnShipmentTab={false} />
          </Tab>
          {formik.values.country && formik.values.country !== 'US' && formik.values.packageContains === 'commodity' &&
            <Tab eventKey='commodities' title='Commodities' disabled={formik.values.isReturnOnly}>
              <Commodities formik={formik} isReturnShipmentTab={false} />
            </Tab>
          }
          {formik.values.country && formik.values.country !== 'US' &&
            <Tab eventKey='customs' title='Customs' disabled={formik.values.isReturnOnly}>
              <Customs formik={formik} isReturnShipmentTab={false} />
            </Tab>
          }
          {(!formik.values.orderNum || (formik.values.orderNum && formik.values.includeReturnLabel)) &&
            <Tab eventKey='returnShipment' title='Return shipment'>
              <Tabs
                activeKey={nestedTabKey}
                onSelect={(k) => setNestedTabKey(k)}
                className='mb-3'
              >
                <Tab eventKey='returnShipmentDetails' title='Return shipment details'>
                  <ReturnShipmentDetails
                    formik={formik}
                    getSpecialServices={getSpecialServices}
                    specialServicesLoading={specialServicesLoading}
                    tabKey={tabKey}
                  />
                </Tab>
                {formik.values.returnData.returnLabelType === 'GROUND_CALL_TAG' ? null :
                  <Tab eventKey='returnOptions' title='Return options'>
                    <Options formik={formik} isReturnShipmentTab={true} />
                  </Tab>}
                {formik.values.returnData.returnLabelType === 'GROUND_CALL_TAG' ? null :
                  <Tab eventKey='returnShipAlert' title='Return ShipAlert/Notifications'>
                    <ShipAlert formik={formik} isReturnShipmentTab={true} />
                  </Tab>}
                {formik.values.returnData.country && formik.values.returnData.country !== 'US' && formik.values.returnData.packageContains === 'commodity' &&
                  <Tab eventKey='returnCommodities' title='Return commodities'>
                    <Commodities formik={formik} isReturnShipmentTab={true} />
                  </Tab>
                }
                {formik.values.returnData.country && formik.values.returnData.country !== 'US' &&
                  <Tab eventKey='returnCustoms' title='Return customs'>
                    <Customs formik={formik} isReturnShipmentTab={true} />
                  </Tab>
                }
              </Tabs>
            </Tab>}
        </Tabs>
        <hr />
        <Toolbar
          formik={formik}
          submitLoading={submitLoading}
          onReturnTab={onReturnTab}
          handleReset={handleReset}
          updateHideLookup={updateHideLookup}
          resetTabs={resetTabs}
        />
      </Form>
      <OrderLookupModal
        formik={formik}
        show={showLookup}
        handleClose={handleCloseLookup}
        handleLookupKeyDown={handleLookupKeyDown}
        lookupPackage={lookupPackage}
        fetchLoading={fetchLoading}
      />
      <PrintDocsModal
        show={showPrintDocs}
        handleClose={handleClosePrintDocs}
        documents={documentsToPrint}
      />
    </>
  );
}

export default App;
